import React, { useEffect, } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Helmet } from "react-helmet";
import Schema from "../components/Schema";

const AboutUs = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      once: true,
    });
  }, []);

  

  // State for zoom modal
  // const [zoomImage, setZoomImage] = useState(null);

  // Images for awards section
  const awardImages = [
    {
      src: "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1748234581/WhatsApp_Image_2025-05-15_at_8.56.46_AM_1_cojlju.jpg",
      alt: "Team from Solar Care International posing with award",
    },
    {
      src: "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1748234581/WhatsApp_Image_2025-05-15_at_8.56.43_AM_1_qptpdn.jpg",
      alt: "Award handover moment during ceremony",
    },
    {
      src: "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1748234580/WhatsApp_Image_2025-05-15_at_8.56.44_AM_1_mhv729.jpg",
      alt: "CEO receiving the award on stage",
    },
  ];

  const certificateImage = {
    src: "https://res.cloudinary.com/dwf8ifbzs/image/upload/v1748234578/WhatsApp_Image_2025-05-15_at_9.07.09_AM_2_ssqtxy.jpg",
    alt: "Certificate awarded by Global Business Excellence Awards 2025",
  };

  return (
    <div className="relative isolate px-4 pt-14 sm:px-6 lg:px-8">
    <Schema />
    <Helmet>
        <title>Dasitha Kodithuwakku | Solar Care International Sri Lanka</title>
        <meta
          name="description"
          content="Solar Care International (Pvt) Ltd, founded by Dasitha Kodithuwakku, is Sri Lanka’s #1 Solar Preventive Maintenance and Aftercare Solutions Provider. Trusted in Sri Lanka & Maldives."
        />
        <meta
          name="keywords"
          content="Dasitha Kodithuwakku, Solar Care International, Sri Lanka solar maintenance, solar preventive maintenance, bird proofing, solar panel cleaning, ChemiTek distributor Sri Lanka"
        />
        <link rel="canonical" href="https://www.solarcareinternational.lk/" />
        <meta property="og:title" content="Dasitha Kodithuwakku | Solar Care International" />
        <meta
          property="og:description"
          content="Sri Lanka’s #1 provider of solar preventive maintenance, installations, and bird proofing. Founded by Dasitha Kodithuwakku."
        />
        <meta property="og:image" content="https://www.solarcareinternational.lk/Images/sci-1024x1024.png" />
        <meta property="og:url" content="https://www.solarcareinternational.lk/" />
        <meta name="twitter:card" content="summary_large_image" />

        {/* Schema Markup */}
        <script type="application/ld+json">{`
        {
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "Solar Care International",
          "url": "https://www.solarcareinternational.lk/",
          "logo": "https://www.solarcareinternational.lk/Images/sci-1024x1024.png",
          "founder": {
            "@type": "Person",
            "name": "Dasitha Kodithuwakku",
            "jobTitle": "Founder & Managing Director",
            "image": "https://www.solarcareinternational.lk/Images/dasitha_image_2.jpeg"
          },
          "contactPoint": [{
            "@type": "ContactPoint",
            "telephone": "+94777129021",
            "contactType": "Customer Service",
            "email": "solarcareinternational@gmail.com",
            "areaServed": ["LK","MV"]
          }],
          "sameAs": [
            "https://web.facebook.com/profile.php?id=100091148180919",
            "https://www.instagram.com/solar_care_international/",
            "https://www.youtube.com/@SolarCareInternational",
            "https://www.tiktok.com/@solarcareinternational",
            "https://wa.me/94777129021"
          ],
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Sri Rahula Maha Vidyalaya, No.11,12",
            "addressLocality": "Sri Jayawardenepura Kotte",
            "postalCode": "10100",
            "addressCountry": "LK"
          }
        }
        `}</script>
      </Helmet>
      <div className="container mx-auto">
        {/* Heading */}
        <h1
          className="text-6xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-7xl 2xl:text-8xl font-bold text-black text-center"
        >
          About Us
        </h1>
        <p
          className="text-xl font-medium text-center text-gray-600 mb-12"
          data-aos="fade-up"
        >
          Renewable energy at its best use
        </p>

        {/* Intro Section with Image Left in Black Box */}
        <div
          className="flex flex-col md:flex-row items-start gap-8 mb-16 bg-black text-white rounded-3xl overflow-hidden"
          data-aos="fade-up"
        >
          {/* Image Section */}
          <div className="md:w-[400px] w-full h-full">
            <img
              src="/Images/dasitha_image_2.jpeg"
              alt="CEO Portrait"
              className="w-full h-full object-cover md:rounded-l-3xl"
              style={{ minHeight: '100%', height: '100%' }}
            />
          </div>

          {/* Text Section */}
          <div className="flex-1 px-6 py-8">
            <h2 className="text-2xl font-bold mb-6 bg-clip-text text-transparent bg-gradient-to-r from-[#a1c4fd] via-[#fbc2eb] to-[#fddb92]">Solar Care International</h2>
            <p className="text-base sm:text-lg text-justify mb-4 leading-relaxed font-light">
          Solar Care International (Pvt) Ltd is Sri Lanka’s No. 1 Solar Preventive Maintenance and Aftercare Solutions Provider. Founded by Dasitha Kodithuwakku — a seasoned Solar PV Sales Coach and Solar Preventive Maintenance Expert — the company has redefined how solar owners protect and maximize their investment. We are also the Exclusive Authorized Distributor of ChemiTek SA (Portugal) for Sri Lanka and the Maldives.
        </p>
        <p className="text-base sm:text-lg text-justify mb-4 leading-relaxed font-light">
          Through collaborations with the Public Utilities Commission of Sri Lanka (PUCSL), SLSEA, YouLead, and CameraLK Technologies, we have empowered thousands of solar owners, institutions, and professionals to adopt and sustain clean energy. To date, over 3,500 technicians have been personally trained in solar sales and preventive maintenance under the guidance of our Founder, Dasitha Kodithuwakku — building the next generation of solar leaders.
        </p>
        <p className="text-base sm:text-lg text-justify leading-relaxed font-light">
          We have safeguarded over 44,000 kW of rooftop solar capacity, ranging from 3 kW residential systems to 10,000 kW industrial plants, making us the trusted partner for long-term solar care.
        </p>
          </div>
        </div>

        {/* Vision and Mission */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-24">
          <div
            data-aos="fade-up"
            className="rounded-3xl p-8"
          >
            <h2 className="text-5xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl 2xl:text-7xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-[#a1c4fd] via-[#fbc2eb] to-[#fddb92] ">
              Our Vision.
            </h2>
            <p className="text-lg text-justify leading-relaxed">
              “To be the driving force in Sri Lanka and the Maldives for a sustainable, renewable energy future where every solar system performs at its best. We aspire to make clean, affordable, and innovative solar solutions accessible to all, creating a world powered by limitless solar energy.”
            </p>
          </div>

          <div
            data-aos="fade-up"
            className="rounded-3xl p-8"
          >
            <h2 className="text-5xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl 2xl:text-7xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-[#a1c4fd] via-[#fbc2eb] to-[#fddb92]">
              Our Mission.
            </h2>
            <p className="text-lg text-justify leading-relaxed">
              “Our mission is to safeguard and maximize the performance of every solar investment by delivering world-class preventive maintenance, protective coatings, and aftercare solutions. We are committed to bridging the post-installation support gap in Sri Lanka and the Maldives through innovation, international partnerships, and trusted service. By empowering communities with reliable solar care, we ensure clean energy remains sustainable, profitable, and future-ready.”
            </p>
          </div>
        </div>

        {/* Core Values Section */}
<div className="mb-24" data-aos="fade-up">
  <h2 className="text-5xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl 2xl:text-7xl font-bold text-center mb-12 bg-clip-text text-transparent bg-gradient-to-r from-[#a1c4fd] via-[#fbc2eb] to-[#fddb92]">
    Our Core Values
  </h2>

  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8 text-center">
    {/* Sustainability */}
    <div className="flex flex-col items-center p-6 bg-gray-50 rounded-2xl shadow-md hover:shadow-xl transition-all">
      <h3 className="text-xl font-semibold mb-2">Sustainability</h3>
      <p className="text-sm leading-relaxed">Eco-friendly practices that protect our planet for future generations.</p>
    </div>

    {/* Innovation */}
    <div className="flex flex-col items-center p-6 bg-gray-50 rounded-2xl shadow-md hover:shadow-xl transition-all">
      <h3 className="text-xl font-semibold mb-2">Innovation</h3>
      <p className="text-sm leading-relaxed">Cutting-edge technologies and smarter solutions for better performance.</p>
    </div>

    {/* Trust & Integrity */}
    <div className="flex flex-col items-center p-6 bg-gray-50 rounded-2xl shadow-md hover:shadow-xl transition-all">
      <h3 className="text-xl font-semibold mb-2">Trust & Integrity</h3>
      <p className="text-sm leading-relaxed">Building long-term relationships through honesty and transparency.</p>
    </div>

    {/* Excellence in Service */}
    <div className="flex flex-col items-center p-6 bg-gray-50 rounded-2xl shadow-md hover:shadow-xl transition-all">
      <h3 className="text-xl font-semibold mb-2">Excellence in Service</h3>
      <p className="text-sm leading-relaxed">International-standard preventive maintenance and customer care.</p>
    </div>

    {/* Customer Empowerment */}
    <div className="flex flex-col items-center p-6 bg-gray-50 rounded-2xl shadow-md hover:shadow-xl transition-all">
      <h3 className="text-xl font-semibold mb-2">Customer Empowerment</h3>
      <p className="text-sm leading-relaxed">Guiding and supporting solar owners to get the best from their investment.</p>
    </div>
  </div>
</div>


{/* Commitment */}
        <div className="mb-24 text-center max-w-4xl mx-auto" data-aos="fade-up">
          <h2 className="text-5xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl 2xl:text-7xl font-bold text-center mb-12 bg-clip-text text-transparent bg-gradient-to-r from-[#a1c4fd] via-[#fbc2eb] to-[#fddb92]">Our Commitment</h2>
          <p className="text-lg leading-relaxed text-gray-700">
            Solar Care International was built to bridge the gap in
            post-installation support — a critical need often overlooked in Sri
            Lanka and the Maldives. Our mission is to ensure long-term
            performance, maximum reliability, and guaranteed return on
            investment for every solar system owner.
          </p>
        </div>

        {/* Services */}
        <div className="mb-24" data-aos="fade-up">
          <h2 className="text-5xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl 2xl:text-7xl font-bold text-center mb-12 bg-clip-text text-transparent bg-gradient-to-r from-[#a1c4fd] via-[#fbc2eb] to-[#fddb92]">
            Our Services
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-left max-w-5xl mx-auto">
            <div className="p-6 bg-gray-50 rounded-xl shadow">
              Preventive Maintenance – ensuring maximum output and system
              reliability
            </div>
            <div className="p-6 bg-gray-50 rounded-xl shadow">
              System Health Reports – detailed diagnostics with recommendations
              for long-term sustainability
            </div>
            <div className="p-6 bg-gray-50 rounded-xl shadow">
              SCI Installation Method – our unique 41-step process ensuring
              world-class quality and safety from installation to operation
            </div>
            <div className="p-6 bg-gray-50 rounded-xl shadow">
              Solar Panel Cleaning & Advanced Protective Coatings – featuring
              ChemiTek’s world-class anti-static and anti-adherent solutions
            </div>
            <div className="p-6 bg-gray-50 rounded-xl shadow">
              Warranty & Claims Handling – complete manufacturer liaison and
              technical support
            </div>
            <div className="p-6 bg-gray-50 rounded-xl shadow">
              Bird-Proofing Solutions – protecting your solar assets against
              contamination and damage
            </div>
            <div className="p-6 bg-gray-50 rounded-xl shadow">
              Semi-Automated & Fully Automated Cleaning Systems – robotic and
              mechanized solutions for large-scale solar arrays
            </div>
          </div>
        </div>

        {/* Achievements */}
<div className="mb-24" data-aos="fade-up">
  <h2 className="text-5xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl 2xl:text-7xl font-bold text-center mb-12 bg-clip-text text-transparent bg-gradient-to-r from-[#a1c4fd] via-[#fbc2eb] to-[#fddb92]">
    Our Achievements
  </h2>

  <p className="text-lg text-center text-gray-700 mb-12 max-w-3xl mx-auto">
    We are proud to be recognized with multiple prestigious awards for our innovation and leadership in the solar sector:
  </p>

  {/* Awards Grid */}
  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
    {/* Award 1 */}
    <div className="p-6 bg-gradient-to-br from-[#fdfbfb] to-[#ebedee] rounded-2xl shadow-lg hover:shadow-2xl transition transform hover:-translate-y-2 text-center">
      <h3 className="text-lg font-semibold mb-2">
        Best Solar Preventive Maintenance Provider <br /> in Sri Lanka 2025
      </h3>
      <p className="text-sm text-gray-600">
        Global Business Excellence Awards
      </p>
    </div>

    {/* Award 2 */}
    <div className="p-6 bg-gradient-to-br from-[#fdfbfb] to-[#ebedee] rounded-2xl shadow-lg hover:shadow-2xl transition transform hover:-translate-y-2 text-center">
      <h3 className="text-lg font-semibold mb-2">
        Most Innovative Solar Company of the Year 2025
      </h3>
      <p className="text-sm text-gray-600">
        Global Business Excellence Awards
      </p>
    </div>

    {/* Award 3 */}
    <div className="p-6 bg-gradient-to-br from-[#fdfbfb] to-[#ebedee] rounded-2xl shadow-lg hover:shadow-2xl transition transform hover:-translate-y-2 text-center">
      <h3 className="text-lg font-semibold mb-2">
        Best Solar Preventive Maintenance Provider <br /> in Sri Lanka 2025
      </h3>
      <p className="text-sm text-gray-600">Iconic Awards</p>
    </div>
  </div>

  {/* Closing Note */}
  <div className="text-center mt-12">
    <p className="text-lg font-medium text-gray-800 italic">
      Solar Care International - Protecting Your Solar Investment, Today and for the Future.
    </p>
    <p className="mt-6 text-sm text-gray-600">
      By Dasitha Kodithuwakku <br />
      Founder & Managing Director <br />
      Solar PV Sales Coach & Preventive Maintenance Expert
    </p>
  </div>
</div>


        {/* Awards Section */}
<div className="mb-32 px-4 sm:px-8 md:px-16" data-aos="fade-up">
  <div className="text-center max-w-4xl mx-auto mb-16">
    <h2 className="text-4xl sm:text-5xl lg:text-6xl 2xl:text-7xl font-bold bg-gradient-to-r from-yellow-400 via-pink-400 to-yellow-300 bg-clip-text text-transparent mb-6 leading-tight p-4">
      Global Recognition
    </h2>
    <p className="text-xl sm:text-2xl text-gray-700 leading-relaxed">
      We’re honored to be recognized as the<br />
      <strong className="text-3xl sm:text-4xl font-semibold text-gray-900">Best Solar Preventive Maintenance Provider in Sri Lanka</strong><br />
      by the Global Business Excellence Awards 2025!
    </p>
  </div>

  {/* Highlighted Certificate Section */}
  <div className="relative rounded-3xl overflow-hidden max-w-6xl mx-auto mb-20">
    <img
      src={certificateImage.src}
      alt={certificateImage.alt}
      className="w-full h-auto object-cover shadow-2xl transition-transform duration-300 hover:scale-105"
    />
    <p className="absolute bottom-4 right-6 text-sm text-gray-100 bg-black/60 px-3 py-1 rounded-full">
      Reg No: SLSEASBS00808PV002747322023ABT2P1
    </p>
  </div>

  {/* Awards Image Row with Large, Airy Layout */}
  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto mb-24">
    {awardImages.map((image, index) => (
      <div key={index} className="overflow-hidden rounded-3xl shadow-lg hover:scale-105 transition-transform duration-300">
        <img
          src={image.src}
          alt={image.alt}
          className="w-full h-full object-cover"
        />
      </div>
    ))}
  </div>

  {/* Video Section */}
  <div className="text-center max-w-4xl mx-auto">
    <video
      controls
      className="w-full shadow-xl"
      src="https://res.cloudinary.com/dwf8ifbzs/video/upload/v1748234594/WhatsApp_Video_2025-05-15_at_9.08.56_AM_2_rbjcja.mp4"
    >
      Your browser does not support the video tag.
    </video>
    <p className="text-sm text-gray-500 mt-3">
      Registration No: SLSEASBS00808PV002747322023ABT2P1
    </p>
  </div>

{/* Recognition Section */}
<div className="text-center max-w-4xl mx-auto mt-20 mb-16 px-4">
  <p className="text-lg sm:text-xl lg:text-2xl text-gray-700 leading-relaxed">
    We’re honored to be recognized as the <br />
    <strong className="text-2xl sm:text-3xl font-semibold text-gray-900">
      Most Innovative Solar Company
    </strong>
    <br />
    by the Global Business Excellence Awards 2025 - Elite Series II
  </p>
</div>

{/* Video Section */}
<div className="text-center max-w-5xl mx-auto mb-20 px-4">
  <video
    controls
    className="w-full shadow-2xl border-gray-200"
    src="https://res.cloudinary.com/dwf8ifbzs/video/upload/v1756118758/WhatsApp_Video_2025-08-25_at_1.58.39_PM_r0fsmd.mp4"
  >
    Your browser does not support the video tag.
  </video>
</div>

{/* Certificates Section */}
<div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl mx-auto mb-20 px-4">
  <div className="relative rounded-3xl overflow-hidden shadow-2xl transition-transform duration-300 hover:scale-105">
    <img
      src="https://res.cloudinary.com/dwf8ifbzs/image/upload/v1756119884/WhatsApp_Image_2025-08-25_at_12.55.35_PM_ewggr6.jpg"
      alt="Most Innovative Solar Company by the Global Business Excellence Awards 2025 - Elite Series II"
      className="w-full h-auto object-cover rounded-3xl"
    />
  </div>

  <div className="relative rounded-3xl overflow-hidden transition-transform duration-300 hover:scale-105">
    <img
      src="https://res.cloudinary.com/dwf8ifbzs/image/upload/v1756120050/WhatsApp_Image_2025-08-25_at_12.55.35_PM_1_opogyy.jpg"
      alt="Most Innovative Solar Company by the Global Business Excellence Awards 2025 - Elite Series II"
      className="w-full h-auto object-cover rounded-3xl"
    />
  </div>

  <div className="relative rounded-3xl overflow-hidden transition-transform duration-300 hover:scale-105">
    <img
      src="https://res.cloudinary.com/dwf8ifbzs/image/upload/v1756118997/WhatsApp_Image_2025-08-25_at_12.55.33_PM_1_gk58s0.jpg"
      alt="Most Innovative Solar Company by the Global Business Excellence Awards 2025 - Elite Series II"
      className="w-full h-auto object-cover rounded-3xl"
    />
  </div>
</div>

{/* Recognition Section */}
<div className="text-center max-w-4xl mx-auto mt-20 mb-16 px-4">
  <p className="text-lg sm:text-xl lg:text-2xl text-gray-700 leading-relaxed">
    We’re honored to be recognized as the <br />
    <strong className="text-3xl sm:text-4xl font-semibold text-gray-900">
      Best Solar Preventive Maintenance Provider
    </strong>
    <br />
    by the Iconic Awards 2025
  </p>
</div>

{/* Video Section */}
<div className="text-center max-w-5xl mx-auto mb-20 px-4">
  <video
    controls
    className="w-full shadow-2xl border-gray-200"
    src="https://res.cloudinary.com/dwf8ifbzs/video/upload/v1756119503/WhatsApp_Video_2025-08-25_at_1.56.43_PM_bjbbkk.mp4"
  >
    Your browser does not support the video tag.
  </video>
</div>

{/* Certificates Section */}
<div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl mx-auto mb-20 px-4">


  {/* Left Side (1 big image) */}
  <div className="relative rounded-3xl overflow-hidden transition-transform duration-300 hover:scale-105">
    <img
      src="https://res.cloudinary.com/dwf8ifbzs/image/upload/v1756120359/Screenshot_2025-08-25_160201_uz9vz5.png"
      alt="Most Innovative Solar Company by the Global Business Excellence Awards 2025 - Elite Series II"
      className="w-full h-auto object-cover rounded-3xl"
    />
  </div>

  {/* Right Side (2 stacked images) */}
  <div className="grid grid-rows-2 gap-8">
    <div className="relative rounded-3xl overflow-hidden transition-transform duration-300 hover:scale-105">
      <img
        src="https://res.cloudinary.com/dwf8ifbzs/image/upload/v1756118997/WhatsApp_Image_2025-08-25_at_12.55.33_PM_1_gk58s0.jpg"
        alt="Most Innovative Solar Company by the Global Business Excellence Awards 2025 - Elite Series II"
        className="w-full h-auto object-cover rounded-3xl"
      />
    </div>

    <div className="relative rounded-3xl overflow-hidden transition-transform duration-300 hover:scale-105">
      <img
        src="https://res.cloudinary.com/dwf8ifbzs/image/upload/v1758103843/DSC_341_drl8j7.jpg"
        alt="Most Innovative Solar Company by the Global Business Excellence Awards 2025 - Elite Series II"
        className="w-full h-auto object-cover rounded-3xl"
      />
    </div>
</div>
</div>
</div>
      </div>
      
    </div>
  );
};

export default AboutUs;
